import TranslatableText from './TranslatableText';

export default TranslatableText;
